import view from './link'
export default view
